import { createContext } from 'react'

export type GlobalActionLoadingOptions = {
  label?: string
  messages?: string[]
  delayMs?: number
  timeoutMs?: number
}

export type GlobalActionLoadingContextValue = {
  isActionLoading: boolean
  runWithGlobalLoading: <T>(
    action: (signal: AbortSignal) => Promise<T> | T,
    options?: GlobalActionLoadingOptions,
  ) => Promise<T | undefined>
}

export const GlobalActionLoadingContext = createContext<GlobalActionLoadingContextValue | undefined>(undefined)
